/** Chart palette on the dark ground (#0c0d0f). One accent, two context greys, hairline grid. */
export const ACCENT = '#ff6b2c';
export const ACCENT_SOFT = 'rgba(255, 107, 44, 0.16)';
export const CONTEXT = '#9a9993';
export const CONTEXT_DIM = '#5c5d62';
export const GRID = '#2c2e33';
export const INK = '#f2efe8';
export const INK_MUTED = '#8f8e8a';
export const INK_FAINT = '#65656a';
export const SURFACE = '#16171b';
export const SURFACE_MUTED = '#1e2025';
export const GROUND = '#0c0d0f';
